module.exports = __webpack_public_path__ + "static/media/(H)_MG_5931_-_bijuterias.fdbd229f.jpg";